<template>
  <v-col align="center">
    <v-card width="1000">
      <v-card-title style="font-weight: bold; font-size: 1.60em; margin-bottom: 3px">
        Confirm your updated Email Address
      </v-card-title>
      <v-card-text>
        <div class="text--primary text-justify">
          Our records indicate your agency's main contact email address has changed. To update your Marketplace registration status, please confirm the email address on file by clicking the Update Registration button.
        </div>
      </v-card-text>
      <v-card-text>
        <v-row class="pa-4">
          <div style="text-align: start">
            A security authentication code will be emailed to you.
          </div>
        </v-row>
        <v-row class="px-4" justify-center>
          <v-text-field v-model="email" label="Enter Email Address:" :error-messages="errorMessage" @keyup.enter="submit()"></v-text-field>
        </v-row>
      </v-card-text>
      <v-card-actions justify-end>
        <v-col>
          <v-btn color="warning" :disabled="loading" @click="submit()">Update Registration</v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-col>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import emailValidatorMixin from '@/mixins/emailValidatorMixin';

export default {
  name: 'RegistrationUpdate',
  mixins: [emailValidatorMixin],
  data () {
    return {
      email: '',
      errorMessage: '',
      loading: false
    };
  },
  computed: {
    ...mapState(['agency'])
  },
  async created () {
    await this.getMainContactEmail();
  },
  methods: {
    ...mapActions(['setAgency', 'setError', 'setRegistration']),
    async submit () {
      // form should pre-populate w/email from CRM API; validate in instance of edge case whereby user needs to set email manually
      if (!this.isValidEmail(this.email)) {
        this.errorMessage = 'Please enter a valid email address.';
        return;
      }

      this.loading = true;

      const response = await this.$api.updateRegistrationEmail(this.email);

      if (response.code === 0) {
        const registrationData = JSON.parse(response.data[0]);

        if (registrationData.code === 'Ok') {
          this.setRegistration(this.email);
          this.$router.push({ path: '/registration/confirmation' });
        } else if (registrationData.code === 'InvalidParameter') {
          this.errorMessage = 'This email address was not listed on the HawkSoft License Agreement as an authorized user for your agency.';
          this.loading = false;
          return;
        } else {
          this.errorMessage = 'An error has occurred. Please wait 10 minutes and try again, or contact HawkSoft support for assistance.';
          this.loading = false;
          return;
        }
        this.setRegistration(this.email);
        this.$router.push({ path: '/registration/confirmation' });
      } else {
        this.errorMessage = 'An error has occurred. Please wait 10 minutes and try again, or contact HawkSoft support for assistance.';
      }

      this.loading = false;
    },
    async getMainContactEmail () {
      this.loading = true;

      if (!this.agency) {
        const agencyIdRes = await this.$api.getAgency();
        if (agencyIdRes.code !== 0) {
          this.setError({ errorMessage: 'Error - Unable to get agency information. Please contact HawkSoft support for assistance.' });
          return;
        }
        this.setAgency(JSON.parse(agencyIdRes.data[0]));
      }

      const mainContactsRes = await this.$api.getMainContacts(this.agency.agencyId);
      if (mainContactsRes.code !== 0) {
        this.setError({ errorMessage: 'Error - Unable to get main contact. Please contact HawkSoft support for assistance.' });
        return;
      }

      const { Email } = JSON.parse(mainContactsRes.data)[0];
      if (!Email) {
        this.setError({ errorMessage: 'Error - Unable to get updated email address on file. Please contact HawkSoft support for assistance.' });
        this.loading = false;
        return;
      }
      this.email = Email;
      this.loading = false;
    }
  }
};
</script>
